import { render } from "./Bill_steps.vue?vue&type=template&id=62f97de1&scoped=true"
import script from "./Bill_steps.vue?vue&type=script&lang=js"
export * from "./Bill_steps.vue?vue&type=script&lang=js"

import "./Bill_steps.vue?vue&type=style&index=0&id=62f97de1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f97de1"]])

export default __exports__